export const getUrlParams = () => {
  let tracking_number;
  let postal_code;
  let serviceId;
  let postal_available;
  // ?tracking_number=hOc5f3RC&postal_code=3062PA
  try {
    var urlParams = new URLSearchParams(window.location.search);
    tracking_number = urlParams.get("tracking_number");
    postal_code = urlParams.get("postal_code");
    serviceId = urlParams.get("serviceId");
    postal_available = urlParams.get("postal_available");
  } catch (e) {
    var queryParams: any = window.location.search
      .substr(1)
      .split("&")
      .reduce(function (q: any, query) {
        var chunks = query.split("=");
        var key = chunks[0];
        var value = chunks[1];
        q[key] = value;
        return q;
      }, {});
    tracking_number = queryParams["tracking_number"];
    postal_code = queryParams["postal_code"];
    serviceId = queryParams["serviceId"];
    postal_available = queryParams["postal_available"];
  }

  return {
    tracking_number,
    postal_code,
    serviceId,
    postal_available
  };
};
